/**
 * @license
 * Copyright Alibaba.com All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

export default {
  // Options.jsx
  items_per_page: '/ ×¢×××',
  jump_to: '×¢×××¨ ××',
  jump_to_confirm: '×××©××¨',
  page: '',

  // Pagination.jsx
  prev_page: '××¢××× ××§×××',
  next_page: '××¢××× ×××',
  prev_5: '5 ×¢××××× ×§×××××',
  next_5: '5 ×¢××××× ×××××',
  prev_3: '3 ×¢××××× ×§×××××',
  next_3: '3 ×¢××××× ×××××'
};
